module.exports = __webpack_public_path__ + "static/media/pk.d9feea05.svg";